

const BagageReducer = (state, action) => {
    switch (action.type) {
        case "GET_BAGAGES_START":
            return {
                ...state,
                bagages: [],
                isFetching: true,
                error: false,
            };
        case "GET_BAGAGES_SUCCESS":
            return {
                ...state,
                bagages: action.payload.bagages,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_BAGAGES_FAILURE":
            return {
                ...state,
                bagages: [],
                isFetching: false,
                error: action.payload,
            };
        default:
            return { ...state };
    }
}

export default BagageReducer;